import { useState } from 'react';
import styles from './DashboardHeader.module.css';

const today = new Date().toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });

function initials(name = '') {
  const p = name.trim().split(' ');
  return ((p[0]?.[0] ?? '') + (p[1]?.[0] ?? '')).toUpperCase();
}

export default function DashboardHeader({ user, school, dismissalTime = '3:00 PM', onLogout }) {
  school = school || user?.school_name || 'School';
  const [dropdownOpen, setDropdownOpen] = useState(false);

  return (
    <div className={styles.header}>
      {/* Left — school */}
      <div className={styles.left}>
        <div className={styles.schoolLogo}>{school.slice(0, 2).toUpperCase()}</div>
        <span className={styles.schoolName}>{school}</span>
      </div>

      {/* Center — live info */}
      <div className={styles.center}>
        {today} &mdash; Live Carpool Dismissal Queue &mdash; Dismissal Time: {dismissalTime}
      </div>

      {/* Right — user avatar + dropdown */}
      <div className={styles.right}>
        <button
          className={styles.avatarBtn}
          onClick={() => setDropdownOpen((v) => !v)}
          aria-label="User menu"
        >
          <div className={styles.avatar}>{initials(user?.name ?? '')}</div>
        </button>

        {dropdownOpen && (
          <div className={styles.dropdown}>
            <div className={styles.dropdownUser}>
              <div className={styles.dropdownAvatar}>{initials(user?.name ?? '')}</div>
              <div>
                <div className={styles.dropdownName}>{user?.name}</div>
                <div className={styles.dropdownRole}>{user?.role ?? 'Staff'}</div>
                <div className={styles.dropdownEmail}>{user?.email}</div>
              </div>
            </div>
            <button
              className={styles.logoutBtn}
              onClick={() => { setDropdownOpen(false); onLogout(); }}
            >
              Logout
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
